import { lazy, Suspense } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import AdminLayout from "./components/AdminLayout";
import { Loader } from "./components/ui";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import { ToastProvider } from "./contexts/ToastContext";
import Login from "./pages/Login";
import { REDIRECTS, ROUTES } from "./routes";

const Privacidade = lazy(() => import("./pages/Privacidade"));

/** Só administradores passam; o resto vai para o login. */
function RequireAdmin({ children }) {
  const { status } = useAuth();
  if (status === "loading") return <Loader page label="Verificando acesso…" />;
  return status === "admin" ? children : <Navigate to="/login" replace />;
}

export default function App() {
  return (
    <ThemeProvider>
      <ToastProvider>
        <AuthProvider>
          <BrowserRouter>
            <Suspense fallback={<Loader page />}>
              <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/privacidade" element={<Privacidade />} />
                <Route
                  element={
                    <RequireAdmin>
                      <AdminLayout />
                    </RequireAdmin>
                  }
                >
                  {ROUTES.map(({ path, page: Page }) => (
                    <Route key={path} path={path} element={<Page />} />
                  ))}
                  {Object.entries(REDIRECTS).map(([de, para]) => (
                    <Route key={de} path={de} element={<Navigate to={para} replace />} />
                  ))}
                  <Route path="*" element={<Navigate to="/" replace />} />
                </Route>
              </Routes>
            </Suspense>
          </BrowserRouter>
        </AuthProvider>
      </ToastProvider>
    </ThemeProvider>
  );
}
